import { RequestNotificationsScreen } from './RequestNotifications'
import { GoToNotificationsSettingsScreen } from './GoToNotificationsSettings'
import { SettingsScreen } from './Settings'
import { CenterScreen } from './Center'

export const NotificationsScreens = {
  Request: RequestNotificationsScreen,
  GoToSystemSettings: GoToNotificationsSettingsScreen,
  Settings: SettingsScreen,
  Center: CenterScreen,
}
